import Vue from 'vue'
import VueI18n from 'vue-i18n'
const enLocale = require('./en.json')
const zhLocale = require('./zh.json')

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
  },
  zh: {
    ...zhLocale,
  },
}
export function getLanguage() {
  const language = (
    navigator.language || navigator.browserLanguage
  ).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
}
const i18n = new VueI18n({
  // set locale
  // options: en | zh |
  locale: getLanguage(),
  // set locale messages
  messages,
})

export default i18n
